import Vue from 'vue';

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get(`subscriberList/rules/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/showRules.js